<template>
  <div class="fixed h-full w-full bg-white bg-opacity-75 top-0 left-0" v-if="loading">
    <div class="spinner">
      <div class="inner">
        <span class="i0"></span>
        <span class="i1"></span>
        <span class="i2"></span>
        <span class="i3"></span>
      </div>
      <div class="outer">
        <span class="o0"></span>
        <span class="o1"></span>
        <span class="o2"></span>
        <span class="o3"></span>
        <span class="o4"></span>
        <span class="o5"></span>
        <span class="o6"></span>
        <span class="o7"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      loading: state => state.loading
    })
  }
}
</script>

<style scoped>
  .inner, .outer {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
  }
  .inner {
    animation: rotate 2s infinite reverse linear;
  }
  .outer {
    animation: rotate 6s infinite linear;
  }
  .inner span, .outer span {
    position: absolute;
    border-radius: 100rem;
    --w: .55rem;
    left: calc(var(--w) * -.5);
    top: calc(var(--w) * -.5);
    width: var(--w);
    height: var(--w);

    @apply bg-black;
  }
  
  .i0 {
    transform: translate(.45rem, 0rem);
  }
  .i1 {
    transform: translate(0rem, .45rem);
  }
  .i2 {
    transform: translate(-.45rem, 0rem);
  }
  .i3 {
    transform: translate(-0rem, -.45rem);
  }

  .o0 {
    transform: translate(1.500rem, 0.000rem);
  }
  .o1 {
    transform: translate(1.061rem, 1.061rem);
  }
  .o2 {
    transform: translate(0.000rem, 1.500rem);
  }
  .o3 {
    transform: translate(-1.061rem, 1.061rem);
  }
  .o4 {
    transform: translate(-1.500rem, 0.000rem);
  }
  .o5 {
    transform: translate(-1.061rem, -1.061rem);
  }
  .o6 {
    transform: translate(-0.000rem, -1.500rem);
  }
  .o7 {
    transform: translate(1.061rem, -1.061rem);
  }


  @keyframes rotate {
    0% {
      transform: rotate(0)
    }
    25% {
      transform: rotate(90deg)
    }
    50% {
      transform: rotate(180deg);
    }
    75% {
      transform: rotate(270deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>